import { render, staticRenderFns } from "./hqglBenefitsClass.vue?vue&type=template&id=73ae033f&scoped=true&"
import script from "./hqglBenefitsClass.vue?vue&type=script&lang=js&"
export * from "./hqglBenefitsClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae033f",
  null
  
)

export default component.exports